// Fotosmile redirect params (d = JWT, k = per-park API key) are bridged through
// sessionStorage so they survive the login round-trip and full page reloads,
// the same way picacode and dateOfStay are bridged elsewhere.
const TOKEN_KEY = 'fotosmile.token'
const API_KEY_KEY = 'fotosmile.apiKey'

export function saveFotosmileParams(token, apiKey) {
    sessionStorage.setItem(TOKEN_KEY, token)
    sessionStorage.setItem(API_KEY_KEY, apiKey)
}

export function getFotosmileParams() {
    return {
        token: sessionStorage.getItem(TOKEN_KEY),
        apiKey: sessionStorage.getItem(API_KEY_KEY),
    }
}

export function hasPendingFotosmileFlow() {
    return !!sessionStorage.getItem(TOKEN_KEY)
}

export function clearFotosmileParams() {
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(API_KEY_KEY)
}
